export function capitalizeFirstLetter(role: any) {
  return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
}
